<template>
    <template v-for="(link, index) in navigation" :key="index">
        <template v-if="link.isTargetExtern">
            <a
                v-if="hasContent(link.link) && hasContent(link.title)"
                :href="link.link"
                :target="link.newTab ? '_blank' : '_self'"
                rel="noreferrer"
                :class="linkStyle"
            >
                {{ link.title }}
            </a>
        </template>
        <template v-else>
            <MiscLink
                v-if="hasContent(link.link) && hasContent(link.title)"
                :to="link.link"
                :target="link.newTab ? '_blank' : null"
                :class="linkStyle"
            >
                {{ link.title }}
            </MiscLink>
        </template>
    </template>

    <a href="#" onclick="UC_UI.showSecondLayer(); return false" :class="linkStyle">
        {{ $t('layout.serviceNavigation.privacySettings') }}
    </a>
</template>

<script setup lang="ts">
import type { Schemas } from '#shopware'
withDefaults(defineProps<{
    navigation: NonNullable<Schemas['CmsElementA4gFooter']['config']>['bottomNavigation']['value']
    linkStyle?: string
}>(), {
    linkStyle: 'text-xs py-3.5 underline hover:no-underline'
})

function hasContent (input: string | null) {
    return (input != null && input.trim() != '')
}
</script>
